import { Injectable } from "@angular/core";
import { snackBarleadIcon } from "../models";
import { snackBarData } from "../models/snackbar-data.model";

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  snackbarData: snackBarData[] = [];

  constructor() {}

  showMessage(type: snackBarData["type"], message: string, data?: Partial<snackBarData>) {
   
    let snackbar: snackBarData = {
      type: type,
      message: message,
      config: {
        autoClose: type === "critical" ? false : true,
        duration: data?.config?.duration || (type === "success" ? 3000 : 0),
      },
      shouldDismissAfterAction: true,
      leadAdornmentConfig: {
        enabled: true,
        type: "icon",
        size: "large",
        iconName: snackBarleadIcon[type as keyof typeof snackBarleadIcon],
      },
      ...(data || {}),
    };
    if (type === "critical") {
      snackbar.trailAdornmentConfig = {
        enabled: true,
        size: "large",
        type: "button",
        buttonConfig: {
          type: "flat",
          color: "neutral",
          label: "OK",
          size: "small",
        },
      };
    }
    this.snackbarData.push(snackbar);
  }
}
